import { useEffect, useRef } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export function InitializeEditorPlugin({ lexicalState }) {
  const [editor] = useLexicalComposerContext();
  const hasInitializedRef = useRef(false);
  const lastStateRef = useRef('');
  
  useEffect(() => {
    if (lexicalState && lexicalState !== lastStateRef.current) {
      console.log('Initializing editor with Lexical state:', lexicalState);
      
      try {
        const parsedState = JSON.parse(lexicalState);
        editor.setEditorState(editor.parseEditorState(parsedState));
        
        console.log('Successfully initialized editor with Lexical state');
      } catch (error) {
        console.error('Error initializing editor with Lexical state:', error);
      }
      
      lastStateRef.current = lexicalState;
      hasInitializedRef.current = true;
    }
  }, [editor, lexicalState]);

  return null;
}